﻿{
  "version": 1,
  "gameId": "ludo",
  "economy": { "offlineEntryCoins": 0, "offlineWinCoins": 0, "offlineWinXp": 20, "offlineLossXp": 0, "onlineEntryCoins": 0, "onlineWinCoins": 0, "onlineWinXp": 0, "onlineLossXp": 0, "rerollCoins": 10, "rerollLimit": 2 },
  "tutorial": {
    "view": "rules",
    "navigationLabelKey": "ludo.rules.navigationLabel",
    "kickerKey": "ludo.rules.kicker",
    "titleKey": "ludo.rules.title",
    "summaryKey": "ludo.rules.summary",
    "sections": [
      { "id": "setup", "key": "ludo.rules.setup" },
      { "id": "enter", "key": "ludo.rules.enter" },
      { "id": "movement", "key": "ludo.rules.movement" },
      { "id": "safe", "key": "ludo.rules.safe" },
      { "id": "capture", "key": "ludo.rules.capture" },
      { "id": "sixes", "key": "ludo.rules.sixes" },
      { "id": "reroll", "key": "ludo.rules.reroll" },
      { "id": "finish", "key": "ludo.rules.finish" },
      { "id": "pass", "key": "ludo.rules.pass" }
    ],
    "settingsAccess": false
  },
  "cosmetics": {
    "boardThemes": [
      { "id": "classic", "nameKey": "ludo.theme.classic", "price": 0, "image": "/assets/boards/Ludo/ludo-board1.jpg" },
      { "id": "fabric", "nameKey": "ludo.theme.fabric", "price": 90, "image": "/assets/boards/Ludo/ludo-board-fabric.jpg" },
      { "id": "bamboo", "nameKey": "ludo.theme.bamboo", "price": 140, "image": "/assets/boards/Ludo/ludo-board-bamboo.jpg" },
      { "id": "jungle", "nameKey": "ludo.theme.jungle", "price": 190, "image": "/assets/boards/Ludo/ludo-board-jungle.jpg" },
      { "id": "ice", "nameKey": "ludo.theme.ice", "price": 180, "image": "/assets/boards/Ludo/ludo-board-ice.jpg" },
      { "id": "stone", "nameKey": "ludo.theme.stone", "price": 210, "image": "/assets/boards/Ludo/ludo-board-stone.jpg" },
      { "id": "neon", "nameKey": "ludo.theme.neon", "price": 260, "image": "/assets/boards/Ludo/ludo-board-neon.jpg" },
      { "id": "volcanic", "nameKey": "ludo.theme.volcanic", "price": 300, "image": "/assets/boards/Ludo/ludo-board-volcanic.jpg" },
      { "id": "sci-fi", "nameKey": "ludo.theme.sciFi", "price": 340, "image": "/assets/boards/Ludo/ludo-board-sci-fi.jpg" },
      { "id": "mario", "nameKey": "ludo.theme.mario", "price": 420, "image": "/assets/boards/Ludo/ludo-board-mario.jpg" }
    ]
  }
}
